import React from 'react';
import styles from '../MarkupViewer.module.scss';

interface DiffListProps {
  differences: Array<{
    type: 'addition' | 'deletion' | 'modification';
    section?: string;
    customerContent?: string | null;
    templateContent?: string | null;
  }>;
  showDifferencesOnly: boolean;
  activeDiffIndex: number;
}

export const DiffList: React.FC<DiffListProps> = ({
  differences,
  showDifferencesOnly,
  activeDiffIndex
}) => {
  return (
    <>
      {differences.map((diff, index) => {
        if (
          showDifferencesOnly &&
          diff.type === 'modification' &&
          !diff.customerContent &&
          !diff.templateContent
        )
          return null;
        const isActive = activeDiffIndex === index;
        return (
          <div
            key={`${diff.section ?? diff.type}-${index}`}
            data-diff-idx={index}
            className={styles.diffSection}
            style={isActive ? { boxShadow: '0 0 0 2px #0b62c133' } : undefined}
          >
            <div
              className={styles.sectionTitle}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <span>{diff.section ?? `Difference ${index + 1}`}</span>
              <span
                style={{
                  fontSize: 11,
                  color: '#667',
                  fontWeight: 500,
                  textTransform: 'uppercase'
                }}
              >
                {diff.type}
              </span>
            </div>
            <div className={styles.diffRow}>
              <div className={`${styles.diffColumn} ${styles.customer}`}>
                <div className={`${styles.diffContent} ${styles[diff.type]}`}>
                  {diff.type === 'addition' && (
                    <span className={styles.indicator}>+ </span>
                  )}
                  {diff.type === 'deletion' && (
                    <span className={styles.indicator}>- </span>
                  )}
                  {diff.type === 'modification' && (
                    <span className={styles.indicator}>~ </span>
                  )}
                  {diff.customerContent ?? <em style={{ opacity: 0.6 }}>—</em>}
                </div>
              </div>
              <div className={`${styles.diffColumn} ${styles.template}`}>
                <div className={styles.diffContent}>
                  {diff.templateContent ?? <em style={{ opacity: 0.6 }}>—</em>}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};
